import { FC, ReactNode } from 'react';

export type StatusTone = 'info' | 'success' | 'warning' | 'error';

const TONE_CLASSES: Record<StatusTone, string> = {
  info: 'text-purple-300 light:text-purple-600',
  success: 'text-green-400 light:text-green-600',
  warning: 'text-yellow-300 light:text-yellow-700',
  error: 'text-status-error light:text-error-muted',
};

export const StatusCard: FC<{
  tone: StatusTone;
  icon: ReactNode;
  title: string;
  announce?: 'status' | 'alert';
  children?: ReactNode;
  actions?: ReactNode;
}> = ({ tone, icon, title, announce = 'status', children, actions }) => (
  <main className="mx-auto mt-16 w-full max-w-xl px-4">
    <section
      role={announce}
      className="rounded-lg border border-slate-500 bg-background-surface p-8 text-center shadow-lg light:bg-white"
    >
      <div
        className={`mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-slate-700 light:bg-gray-100 ${TONE_CLASSES[tone]}`}
        aria-hidden="true"
      >
        {icon}
      </div>
      <h1 className="mt-4 font-heebo text-xl font-semibold text-white light:text-gray-900">
        {title}
      </h1>
      <div className="mt-3 text-sm leading-6 text-gray-300 light:text-gray-700">{children}</div>
      {actions && (
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">{actions}</div>
      )}
    </section>
  </main>
);
